$(function ($) {

    /*---------------- Responsive Menu ------------------*/
    $(".nav-trigger").on('click', function (e) {
        $("body").toggleClass('off-canvas-body');
        $(".menu-bar").toggleClass("off-canvas");
        e.preventDefault();
    });
    if ($(window).width() < 1199) {
        $('.primary-navbar .dropdown > a').on("click", function (e) {
            $(this).next('.dropdown-menu').toggle();
            e.stopPropagation();
            e.preventDefault();
        });
    }

    /*---------------- Main Slider ------------------*/
    $('.main-slider').slick({
        autoplay: false,
        arrows: false,
        dots: true
    });
  
   /*---------------- Shop Slider ------------------*/
 /*   $('.shop-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      vertical: true,
      verticalSwiping: true,
      asNavFor: '.shop-slider-nav'
    });
    $('.shop-slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.shop-slider',
      dots: false,
      arrows: false,
      centerMode: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
    });*/
    /*---------------- Best Seller Slider ------------------*/
   
 
    /*---------------- Filter Toggle ------------------*/
      if ($(window).width() < 767) {
        $('.sidebar-content .title').click(function () {
            $(this).toggleClass('open');
            $(this).parent().find('.inner-content').toggle();
        });
    }
  
});

